import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarAdmin from "../NavbarAdmin/NavbarAdmin";
import FooterIndex from "../../components/footerHomePage/footerHomePage";

const ListProveedores = () => {
  const [sales, setSales] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_GET_ALL_PROVEEDOR);
      setSales(response.data);
    } catch (error) {}
  };

  return (
    <div className="backgounrdprov">
      <NavbarAdmin />
      <div className="allboxlistprovadmin">
        <div className="alllistprov">
          <div className="headerlistprovadmin">
            <p
              id="listprov"
              className="infoprovlistletter leftlistprev firtsborder"
            >
              Nombre del Proveedor
            </p>
            <p id="listprov" className="infoprovlistletter bottonlistprev">
              Cuit
            </p>
            <p id="listprov" className="infoprovlistletter bottonlistprev">
              Estado
            </p>
            <p
              id="listprov"
              className="infoprovlistletter bottonlistprev lastborder"
            >
              Tipo
            </p>
          </div>
          {sales.map((sale, index) => (
            <div className="headerlistprovadmin marginlistprov" key={index}>
              <p id="listprov" className="infoprovlistletter leftlistprev2">
                {sale.nameAndLastName}
              </p>
              <p id="listprov" className="infoprovlistletter leftlistprev2">
                {sale.cuit}
              </p>
              <p id="listprov" className="infoprovlistletter bottonlistprev2">
                {sale.status}
              </p>
              <p id="listprov" className="infoprovlistletter bottonlistprev2">
                {sale.type}
              </p>
            </div>
          ))}
        </div>
      </div>
      <FooterIndex />
    </div>
  );
};

export default ListProveedores;
